import React from 'react';
import cx from 'classnames';
import SliderContext from './context'
import ShowDetailsButton from './ShowDetailsButton'
import Mark from './Mark'
import './Item.css'

const Item = ({ movie, id, storyHeader }) => (
  <SliderContext.Consumer>
    {({ onSelectSlide, currentSlide, elementRef }) => {
      const isActive = currentSlide && currentSlide.id === movie.id;

      return (
        <div
          ref={elementRef}
          className={cx('item', {
            'item--open': isActive,
          })}
          onClick={() => onSelectSlide(movie, id, storyHeader)}
        >
          <img src={movie.titleImageSrc} width={150} height={200} alt="" />
          <ShowDetailsButton onClick={() => onSelectSlide(movie, id)} />
          {isActive && <Mark />}
          <div onClick={() => onSelectSlide(movie, id)} className="textLabel">{movie.name}</div>
        </div>
      );
    }}
  </SliderContext.Consumer>
);

export default Item;
